import React from 'react';
import {PhoneHQConfirmDialog} from 'ch3-ui-lib';

interface DuplicateGroupDialogProps {
    open: boolean;
    /** True when the clash was on the typed name rather than on "no name". */
    named?: boolean;
    onViewGroup: () => void;
    onCancel: () => void;
}

/**
 * A group with exactly these members already exists — either unnamed, or under
 * the name just typed.
 *
 * Reopening it silently looks like the create button did nothing, and leaves no
 * hint about what would produce a second group. In both cases the answer is a
 * name, so say which one is needed.
 */
export const DuplicateGroupDialog: React.FC<DuplicateGroupDialogProps> = ({
    open,
    named,
    onViewGroup,
    onCancel,
}) => (
    <PhoneHQConfirmDialog
        open={open}
        onOpenChange={(isOpen: boolean) => {
            if (!isOpen) onCancel();
        }}
        title="Group already exists"
        cancelLabel="Cancel"
        confirmLabel="View group"
        onConfirm={onViewGroup}
    >
        {named
            ? 'A group with this name and these members already exists. To create another, give it a different name.'
            : 'This unnamed group already exists. To create a new group, give it a name.'}
    </PhoneHQConfirmDialog>
);
